import BigPanel from "../../components/BigPanel/BigPanel";

function AGB() {
  return (
    <BigPanel title="Allgemeine Geschäftsbedingungen (AGB) der Fit-to-Clean Gebäudereinigung Christian Schweiger e.K. für die Erbringung von Gebäudereinigungs-Leistungen">
      <h2>§ 1 Allgemeines – Geltungsbereich</h2>
      <p>
        1. Die Geschäftsbedingungen gelten für alle gegenwärtigen und zukünftigen
        Geschäftsbeziehungen mit Unternehmen im Sinne des § 14 des
        Bürgerlichen Gesetzbuchs (BGB), juristischen Personen des öffentlichen
        Rechts und öffentlich-rechtlichen Sondervermögen.
      </p>
      <p>
        2. Abweichende oder ergänzende Allgemeine Geschäftsbedingungen werden,
        selbst bei Kenntnis, nur Bestandteil, wenn ihrer Geltung ausdrücklich
        zugestimmt wird.
      </p>

      <h2>§ 2 Art und Umfang der Leistung</h2>
      <p>
        1. Vereinbarungen zwischen dem Auftraggeber und dem Auftragnehmer sind
        verbindlich, wenn der Auftraggeber ein Angebot oder einen Auftrag
        unterzeichnet, der diese Bedingungen enthält. Dasselbe gilt, wenn der
        Auftraggeber die schriftliche Auftragsbestätigung vor Beginn der Arbeiten
        erhalten hat.
      </p>
      <p>
        2. Die Leistungen werden wie im Angebot bzw. Auftrag vereinbart
        ausgeführt. Auftragsänderungen oder -erweiterungen haben nur Gültigkeit,
        wenn sie nach Art und Umfang schriftlich, im Ausnahmefall mündlich, von
        den hierzu autorisierten Personen festgelegt werden.
      </p>

      <h2>§ 3 Abnahme und Gewährleistung</h2>
      <p>
        1. Die Werkleistungen des Auftragnehmers gelten bei wiederkehrenden
        Leistungen als auftragsgerecht erfüllt und abgenommen, wenn der
        Auftraggeber nicht unverzüglich – spätestens bei Ingebrauchnahme –
        schriftlich begründete Einwände erhebt. Zeit, Ort, Art und Umfang des
        Mangels müssen genau beschrieben werden.
      </p>
      <p>
        2. Bei einmaligen Werkleistungen (z.&nbsp;B. Bauendreinigung) erfolgt die
        Abnahme – ggf. auch abschnittsweise – spätestens drei Tage nach
        schriftlicher Meldung der Fertigstellung durch den Auftragnehmer. Kommt
        der Auftraggeber der Aufforderung zur Abnahme nicht nach, gilt das Werk
        als abgenommen. Bei Nichtwahrnehmung eines Abnahmetermins durch den
        Auftragnehmer gilt das Werk als nicht abgenommen.
      </p>

      <h2>§ 4 Aufmaß</h2>
      <p>
        1. Die der Abrechnung zugrunde liegenden Maße sind gemäß den Richtlinien
        für Vergabe und Abrechnung des Bundesinnungsverbandes des
        Gebäudereinigerhandwerks zu ermitteln.
      </p>
      <p>
        2. Falls der Auftraggeber der Ermittlung nicht unverzüglich widerspricht,
        gelten die Maße als anerkannt.
      </p>
      <p>
        3. Stellt eine Vertragspartei fest, dass die zugrunde gelegten Maße
        unrichtig sind, gelten die gemeinsam neu festgestellten Maße nur für
        zukünftige Abrechnungen. Erstattungen oder Nachforderungen für die
        Vergangenheit sind ausgeschlossen.
      </p>

      <h2>§ 5 Preise</h2>
      <p>
        Die im Angebot festgelegten Preise beziehen sich auf die zum Zeitpunkt der
        Abgabe des Angebotes geltenden tariflichen und gesetzlichen,
        insbesondere sozialversicherungs- und steuerrechtlichen Bestimmungen.
        Bei deren Änderungen ändern sich auch die Preise entsprechend. Alle
        Preise sind Nettopreise und verstehen sich zuzüglich der gesetzlichen
        Mehrwertsteuer.
      </p>

      <h2>§ 6 Sicherheitseinbehalt</h2>
      <p>
        Das Recht des Auftraggebers, Sicherheitsbeträge für die Fertigstellung
        der vertraglichen Leistungen oder eventuelle Gewährleistungsansprüche
        einzubehalten, ist ausgeschlossen.
      </p>

      <h2>§ 7 Haftung</h2>
      <p>
        1. Für Schäden, die nachweislich auf Reinigungsmaßnahmen zurückzuführen
        sind, haftet der Auftragnehmer im Rahmen der von ihm abgeschlossenen
        Betriebshaftpflichtversicherung. Auf Wunsch des Auftraggebers ist ein
        entsprechender Versicherungsnachweis auszuhändigen. Für Schäden, die
        nicht unverzüglich gemeldet werden, entfällt die Haftung.
      </p>
      <p>
        2. Bei Verletzung von Leben, Körper oder Gesundheit gelten die
        gesetzlichen Bestimmungen.
      </p>
      <p>
        3. Werden berechtigte Mängel beanstandet, ist der Auftragnehmer zur
        Nachbesserung verpflichtet. Für Mängel oder Schäden, die auf fehlende
        oder fehlerhafte Angaben des Auftraggebers zur Art und Beschaffenheit
        der zu reinigenden Flächen oder auf mangelnde Zugänglichkeit
        zurückzuführen sind, wird keine Gewährleistung übernommen.
      </p>
      <p>
        4. Ist eine Nachbesserung nicht möglich oder unzumutbar, kann der
        Auftraggeber Minderung verlangen oder den Vertrag kündigen. Bei
        geringfügigen Mängeln ist eine Kündigung ausgeschlossen.
      </p>
      <p>
        5. Schadensersatz kann nur bei Vorsatz oder grober Fahrlässigkeit verlangt
        werden und ist auf den vertragstypisch vorhersehbaren Schaden begrenzt.
        Bei einmaligen Leistungen ist er auf die Höhe des Werklohns, bei
        wiederkehrenden Leistungen auf zwei Monatsvergütungen begrenzt.
      </p>
      <p>6. Die Gewährleistungsfrist beträgt 12 Monate.</p>

      <h2>§ 8 Zahlungsbedingungen</h2>
      <p>
        1. Rechnungen sind innerhalb von 7 Tagen nach Erhalt ohne Abzug zu
        zahlen. Skontoabzüge werden nicht anerkannt.
      </p>
      <p>
        2. Monatspauschalen sind spätestens am letzten Tag des laufenden Monats
        fällig.
      </p>
      <p>
        3. Bei Zahlungsverzug werden Verzugszinsen in Höhe von 8&nbsp;% über dem
        jeweils gültigen Basiszinssatz gemäß § 247 BGB berechnet. Die
        Geltendmachung weiterer Verzugsschäden bleibt vorbehalten.
      </p>

      <h2>§ 9 Gerichtsstand</h2>
      <p>
        Ausschließlicher Gerichtsstand ist der Sitz des Auftragnehmers. Es gilt
        ausschließlich deutsches Recht.
      </p>

      <h2>§ 10 Schlussbestimmungen und Salvatorische Klausel</h2>
      <p>
        Sollten einzelne Bestimmungen unwirksam sein, bleibt die Wirksamkeit der
        übrigen Regelungen unberührt. Anstelle der unwirksamen Klausel tritt eine
        Regelung, die dem wirtschaftlichen und rechtlichen Zweck am nächsten
        kommt.
      </p>
    </BigPanel>
  );
}

export default AGB;
